import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DocumentsFileList.html?raw';
import SearchSelect from '../../../../../moreCore/UI/SearchSelect/SearchSelect';
import StaticTable from '../../../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../../../_loadingHelpers/VAMv2Types";
import EntityStore from '../../../../../moreCore/Tools/EntityStore';
import FileUpload from '../../../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
//import FileUploadDisplay_ListRow = require("../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow");
import { FileUploadTypes } from "../../../../../moreCore/UI/Filetransfer/FileUpload/FileUploadTypes";
import FileUploadDisplay_ListRow from '../../../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import PageStack from '../../../../../moreCore/UI/Tabbing/PageStack';

import filePreview from '../../../../../WidgetCollection/filePreview/filePreview';

class DocumentsFileList extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    private fileCategories: Array<{ ID: string, description: string }> = [];

    private pagestack: MdsLax<InstanceType<typeof PageStack>>;

    private tableContainer: HTMLElement;
    private filesTable: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.VtFiles | VAM2types.FileUploadWithCategories>>>;
    private documentId: string;
    private className: string;
    private entitylist: Array<VAM2types.FileWithCategory> = [];

    private uploadedFiles: Array<VAM2types.FileUploadWithCategories> = [];
    private removedFiles: Array<string> = [];

    private filePreviewWidget:MdsLax<InstanceType<typeof filePreview>>;

    private _emitHandle: any = null;
    private _delayHandle: any = null;

    private _onChange_StoreData() {
        let diffData = this.store.getDiffData();
        let completeList = this.store.getCurrentCompleteList();


        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.uploadedFiles), 100);
    }


    getData(): EntityStoreData<VAM2types.VtFiles> {
        let data: EntityStoreData<VAM2types.VtFiles> = {
            changed: [],
            deleted: [],
            new: []
        };

        let storeData = this.store.getDiffData();

        data.new = this.uploadedFiles as any;

        data.deleted = storeData.deleted;
        data.changed = storeData.changed as any;

        return data;
    }

    private extendFileupload(uploadData: FileUploadTypes.UploadUnit): VAM2types.FileUploadWithCategories {

        let pseudoFiles = [];
        let count = 0;
        let exFile: VAM2types.FileUploadWithCategories = {
            ...uploadData,
            fileCategories: [],
        }
        for (let filename of uploadData.filenames) {
            exFile.fileCategories.push({
                category: this.fileCategories[0].ID,
                fileName: filename,
                description: this.fileCategories[0].description
            })
        };
        //for (let i = 0; i < uploadData.filenames.length; i++) {
        //    exFile.fileCategories.push({
        //        category: this.fileCategories[i].ID,
        //        fileName: uploadData.filenames[i],
        //        description: this.fileCategories[i].description
        //    })
        //}

        return exFile;
    }

    private _onRemovedUpload(removedFile: FileUploadTypes.UploadDescriptor) {

        // TODO: Pseudoentry im Store finden (! mit guid und count nicht möglich, weils ja gerade entfernt worden ist!!) und entfernen,
        // damit sich die Liste neu zeichnet.
        var currentCompleteList = this.store.getCurrentCompleteList();
        var listItem:VAM2types.VtFiles;
        for (listItem as any of currentCompleteList) {
            if (listItem.ID.match(removedFile.uploadGUID)) {
                this.store.deleteEntry(listItem);
            }
        }
        //// Liste der Uploads aktualisieren:
        //for (let i = 0; i < this.uploadedFiles.length; i++) {
        //    let upload = this.uploadedFiles[i];
        //    if (removedFile.uploadGUID == upload.guid) {
        //        this.uploadedFiles.splice(i, 1);

        //        this._onChange_StoreData();

        //        this._onChangeUploadFile();
        //        return;
        //    }
        //}
    }

    private _onRowDeleting(data): void {
        var entity = data.entity;

        if (entity.ID.match("__") || entity.ID.length > 17) {
            var guid = data.entity.ID.split("__")[0];
            var filename = data.entity.filename;
            this.fileUpload.removeUploadedFile(guid, filename);
        }
    }


    private _onChangeUploadFile() {
        let newFilesData = this.fileUpload.getValue();

        if (newFilesData && this.fileUpload.validateInput()) {

            newFilesData.forEach(file => {

                let guid = file.guid;
                let fileNames = file.filenames
                let existingFile = this.store.getEntityById(guid);

                if (!existingFile) {
                    let exfile = this.extendFileupload(file);

                    this.uploadedFiles.push(exfile);

                    let count = 0;
                    for (let filename of exfile.filenames) {
                        count++;
                        let pseudofile: VAM2types.FileWithCategory = {
                            filename: filename,
                            ref_file_category: this.fileCategories[0],
                            ID: exfile.guid + "__" + count,

                        }
                        this.store.addEntry(pseudofile);
                    }
                }
            });


        } else {

        }
    }

    private _loadFileCategoriesList(): void {

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_AddressDocuments_GetFileCategoriesList",
            {
                className: this.className
            },
            (response: any) => {
                this.fileCategories = response;
                this.fileUpload.resetFileUpload();
                if (this.uploadedFiles.length > 0) {
                    this.fileUpload.loadFileUploadFromData(this.uploadedFiles);
                }
                this.uploadedFiles = [];
            },
            (err) => { this.showToast(err.Message) }
        )
    }

    protected _onUploadRowCreated(evt: { name: string, row: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> }): void {
        let fileRow = evt.row;

        let selectBox = new SearchSelect();

        selectBox.labelAttribute = "description";
        selectBox.setLabel(this.translations["General_Label_Category"]);
        //selectBox.setSelectionListLEGACY(this.fileCategories);
        

        selectBox.on("change", lang.hitch(this, this.assignCategoryToNewFile, fileRow, selectBox));

        let categoryToSet = this.fileCategories[0].ID;

        if (this.uploadedFiles.length > 0) {
            let file = fileRow.getData();
            let uploadedFile = this.uploadedFiles.filter((f) => f.guid == file.uploadGUID)[0];

            let uploadedFileCategory = uploadedFile?.fileCategories.filter((c) => c.fileName == file.FileName)[0].category;

            if (uploadedFileCategory) {
                categoryToSet = uploadedFileCategory;
                selectBox.setReadonly(true);
            }
        }

        //selectBox.setValue(categoryToSet);
        selectBox.setData(categoryToSet, this.fileCategories, false, "description");

        fileRow.addContent_LEGACY(true, selectBox.domNode);
    }

    private assignCategoryToNewFile(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, categorySelect: MdsLax<InstanceType<typeof SearchSelect>>, value: string): void {
        
        let file = fileRow.getData();
        let rowFileGuid = file.uploadGUID
        let rowFileName = file.FileName;

        let targetUpload: VAM2types.FileUploadWithCategories = null;
        for (let upload of this.uploadedFiles) {
            if (rowFileGuid == upload.guid) {
                targetUpload = upload;
                break;
            }
        }

        let selectedCategory = categorySelect.getValue(true) as { ID: string, description: string };

        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (targetUpload) {
            let count = 1;
            for (let categoryAssignment of targetUpload.fileCategories) {
                
                if (categoryAssignment.fileName == rowFileName) {
                    
                    categoryAssignment.category = selectedCategory?.ID;
                    categoryAssignment.description = selectedCategory?.description;

                    this.store.setEntityAttributeValue(rowFileGuid + "__" + count, "ref_file_category", selectedCategory);

                }
                count++;
            }
        }
    }

    private _downloadFile(file): void {
        if (this.hasFeature("filePreview", "useInAddressWizard") == false){
            if (file.entity.Classname) {
                window.open(window.appRoot + `Downloads/DownloadFile?downloadKey=${file.entity["ID"]}`);
            } else {
                this.showToast(this.translate("General_Error_FileNotUploaded"), "fas fa-exclamation-triangle");
            }
        }else{
            this.StandbyStart();
            this.filePreviewWidget = new filePreview();
            this.filePreviewWidget.show(
                {key:file["entity"]["ID"]},
                true,
                true,
                lang.hitch(this, ()=>{
                    this.StandbyStop();
                }),
                lang.hitch(this, ()=>{
                    this.showToast(this.translate("General_Error"), "fas fa-exclamation-triangle");
                    this.StandbyStop();
                })
            );
        }
    }
    setClassName(className: string) {

        this.className = className;
    }

    setup(existingFiles: Array<VAM2types.FileWithCategory>, deletedFiles = [], newFiles: Array<VAM2types.FileUploadWithCategories> = [], documentId: string, className: string) {

        this.entitylist = [];
        this.removedFiles = deletedFiles;

        for (let file of existingFiles) {
            if (this.removedFiles.indexOf(file.ID) == -1) this.entitylist.push(file);
        }
        for (let file of newFiles) {

            for (let i = 0; i < file.filenames.length; i++) {
                this.entitylist.push({
                    ID: file.guid,
                    filename: file.filenames[i],
                    ref_file_category: {
                        ID: file.fileCategories[i].category,
                        description: file.fileCategories[i].description
                    }
                });
            }
        }

        this.store.setup(this.entitylist, "ID");
        this.documentId = documentId;
        this.setClassName(className);

        this.uploadedFiles = newFiles;
    }

    private getMoreNamesString(names: Array<string>): string {
        let finalString: string;

        finalString = names.join(", ");
        if (finalString.length > 16) {
            finalString = finalString.slice(0, 16) + '[...]';
        }
        return finalString;
    }
    private setupTable(response: { layouts: Array<any> }): void {

        //if (this.filesTable != null) this.filesTable.destroy();

        //this.filesTable = new StaticTable();

        //this.filesTable.placeAt(this.tableContainer);
        this.filesTable.setLayout(response.layouts[0]);

        this.filesTable.addDefaultRowActionButton("delete", lang.hitch(this, this._onRowDeleting));//, ;

        let downLoadIcon:string = "fas fa-download";
        if (this.hasFeature("filePreview", "useInAddressWizard")){
            downLoadIcon = "fas fa-search";
        }
        this.filesTable.addCustomRowActionButton("download", lang.hitch(this, this._downloadFile), downLoadIcon);

        this.filesTable.setupFromStore(this.store);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;

        this.filesTable = new StaticTable();
        this.filesTable.placeAt(this.tableContainer);
        this.filesTable.setCyAttribute("documentsFileList");

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.fileUpload.on("complete_remove", lang.hitch(this, this._onRemovedUpload))
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_AddressDocuments_GetFileTableLayout",
            null,
            lang.hitch(this, this.setupTable),
            (err) => { this.showToast(err.Message) }
        )

        this.fileUpload.on("NewRowCreated", lang.hitch(this, this._onUploadRowCreated));

        if (this._delayHandle) clearTimeout(this._delayHandle);
        this._delayHandle = setTimeout(lang.hitch(this, this._loadFileCategoriesList), 150);

        this.pagestack.activatePageByName("files_default");
    }
}

export default mdsWidget(DocumentsFileList);
